import { styled } from '../../styles';
export const EmphasisSpan = styled('span') `
    font-style: italic;
    font-weight: 600;
`;
//# sourceMappingURL=emphasis_span.js.map